import React from 'react'

import { css } from '@emotion/react'

/**
 *
 */
const EULALayout = ({ children }) => (
  <div
    css={css`
      @media print {
        color: black;
      }

      padding: 1rem;
      margin-bottom: 5rem;

      ol {
        ol {
          list-style-type: lower-alpha;
        }
      }

      ul,
      ol {
        margin-bottom: 1rem;
      }

      a {
        background: rgb(255 255 255 / 10%);
        text-decoration: underline;

        &:hover {
          background: rgba(255, 255, 255, 0.2);
        }
      }
    `}
  >
    {children}
  </div>
)

export default EULALayout
